var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Text, View } from 'react-native';
import { checkIsPlatform, getTestId } from '../../../../utils';
import { getTypographyStyles } from '../../TypographyStyles';
import { SingleText } from '../single-text/SingleText';
export var MultipleText = forwardRef((typographyProps, ref) => {
  var typographyStyles = getTypographyStyles(typographyProps);
  var multiText = typographyProps.multiText,
    _typographyProps$test = typographyProps.testID,
    testID = _typographyProps$test === void 0 ? 'MultipleText' : _typographyProps$test,
    numberOfLines = typographyProps.numberOfLines,
    removeMulitextParent = typographyProps.removeMulitextParent,
    parentTagName = typographyProps.tagName,
    restProps = __rest(typographyProps, ["multiText", "testID", "numberOfLines", "removeMulitextParent", "tagName"]);
  var childJsx = _jsx(_Fragment, {
    children: multiText === null || multiText === void 0 ? void 0 : multiText.map((singleText, index) => {
      var _ref = singleText || {},
        childTagName = _ref.tagName,
        _ref$text = _ref.text,
        text = _ref$text === void 0 ? '' : _ref$text;
      if (parentTagName && !childTagName && checkIsPlatform('web')) {
        return _jsx(_Fragment, {
          children: text
        });
      }
      return _jsx(SingleText, Object.assign({}, restProps, singleText, {
        multiText: multiText
      }, getTestId(testID, "multiText_" + index)), "singleText_" + index);
    })
  });
  if (parentTagName && checkIsPlatform('web')) {
    var CustomTag = parentTagName;
    var textStyles = [typographyStyles.typography, typographyStyles.multiTextAlignText, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.style];
    var flattenedStyles = Object.assign({}, ...textStyles.filter(Boolean), {
      lineHeight: typographyStyles.typography.lineHeight + "px",
      marginBlock: 0,
      marginInline: 0
    });
    return _jsx(CustomTag, Object.assign({
      ref: ref
    }, getTestId(testID), checkIsPlatform('web') && {
      tabIndex: 0
    }, {
      style: flattenedStyles
    }, {
      children: childJsx
    }));
  }
  if (removeMulitextParent) {
    return _jsx(View, Object.assign({
      style: [{
        flexDirection: 'row',
        flexWrap: 'wrap'
      }, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.style]
    }, getTestId(testID), checkIsPlatform('web') && {
      tabIndex: 0
    }, {
      children: childJsx
    }));
  }
  return _jsx(Text, Object.assign({}, typographyProps, {
    numberOfLines: numberOfLines,
    ref: ref,
    style: [!numberOfLines && typographyStyles.multiTextAlignText, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.style]
  }, getTestId(testID), checkIsPlatform('web') && {
    tabIndex: 0
  }, {
    children: childJsx
  }));
});